import { InjectionToken } from '@angular/core';
import {SocketRoomHandlerPort} from "../ports/socket-room-handler.port";

export const SOCKET_ROOM_HANDLER = new InjectionToken<SocketRoomHandlerPort>('SocketRoomHandlerService');
